import React from "react";
import { useParams } from "react-router-dom";
import ReconsiderationCommon from "../../../../../components/common-content/reconsideration/ReconsiderationCommon";
import Loader from "../../../../../components/custom/Loader";
import AgreementPreviewFormOne from "../../../../../components/preview_applications/agreement/AgreementPreviewFormOne";
import AgreementPreviewFormTwo from "../../../../../components/preview_applications/agreement/AgreementPreviewFormTwo";
import PaymentPreview from "../../../../../components/preview_applications/payment/PaymentPreview";
import { useGetSubmittedAgreementDetailsQuery } from "../../../../../redux/api/submittedCopyrightAgreementApiSlice";
import { AgreementGenerateAttachments } from "../../../../../utils/agreementGenerateAttachArray";
import { useAuth } from "../../../../../utils/authorization";
import { transformAgreementData } from "../../../../../utils/transformAgreementData";
import CommonDetails from "../../details/CommonDetails";

const ReconsiderationAgreementDetails = () => {
  const { authUser } = useAuth();
  const { id } = useParams();
  const { data, isLoading } = useGetSubmittedAgreementDetailsQuery(id, {
    refetchOnMountOrArgChange: true,
  });

  const documents = data?.data;

  if (isLoading) {
    return <Loader />;
  }

  const forInfo = transformAgreementData(documents);

  const infoTable = AgreementGenerateAttachments(forInfo);

  const info = {
    fileStatus: Number(data?.data?.fileStatus),
    noteNumber: data?.data?.trackReg,
    regNumber: "",
    applicantName: data?.data?.applicantName,
    workTitle: data?.data?.documents?.worktitle,
    category: data?.data?.documents?.category?.name,
    amount: data?.data?.amount,
    challan: Number(data?.data?.st) === 3 ? "চালান" : "ট্রেজারি",
    challanNumber:
      Number(data?.data?.st) === 3
        ? data?.data?.echallanId
        : data?.data?.treasuryNo,
    treasuryDate: data?.data?.treasuryDate || new Date(),
    admin: data?.data?.admin,
    fromAdmin: data?.data?.fromAdmin,
    comments: data?.data?.comments[data?.data?.comments.length - 1] || {},

    basicStatus: Number(data?.data?.basicStatus),
    treasuryStatus: Number(data?.data?.treasuryStatus),
  };

  const formOne = (
    <div className="p-4 mt-5">
      <AgreementPreviewFormOne data={data?.data} />
    </div>
  );
  const formTwo = (
    <div className="pt-5">
      <AgreementPreviewFormTwo data={data?.data} />
    </div>
  );

  const comments =
    authUser?.id === 8
      ? data?.data?.comments.find((c) => Number(c.submit) === 2)
      : data?.data?.comments.length > 0 && data?.data?.comments[0];

  const commentsValue = data?.data?.comments.find(
    (c) => Number(c.submit) === 2
  );

  const noteSheetList =
    data?.data?.comments.filter((c) => Number(c.submit) === 1) ?? [];

  const commentsNoteSheet = {
    noteSheetList,
    noteSheetValues: comments?.status,
  };
  const breadcrumbsTitle =
    Number(data?.data?.fileStatus) === 33
      ? "অনুমোদন পুনর্বিবেচনা"
      : Number(data?.data?.fileStatus) === 34
      ? "নথিজাত পুনর্বিবেচনা"
      : "অননুমোদন পুনর্বিবেচনা";

  const content = (
    <ReconsiderationCommon
      comments={commentsValue}
      info={info}
      breadcrumbsTitle={breadcrumbsTitle}
    />
  );
  return (
    <div>
      <CommonDetails
        content={content}
        commentsNoteSheet={commentsNoteSheet}
        formOne={formOne}
        formTwo={formTwo}
        payment={
          <div className="p-4 mt-5">
            <PaymentPreview data={data?.data} />
          </div>
        }
        info={info}
        infoTable={infoTable}
        breadcrumbsTitle={breadcrumbsTitle}
        breadcrumbsTitle2={"পুনর্বিবেচনার নথি"}
      />
    </div>
  );
};

export default ReconsiderationAgreementDetails;
